// 引入 Vue
// import Vue from 'vue'
// Facebook Pixel ID
let fb_dynamic_pixelId = ''

// 获取当前页面 URL
const initUrl = window.location.href

// 获取 URL 参数
function getUrlIDParams() {
  const queryString = initUrl.match(/[?&]id=([^&]+)/)
  if (queryString && queryString[1]) {
    return queryString[1]
  }
  return ''
}

function getUrlFBParams() {
  const questionMarkIndex = initUrl.indexOf('?')
  const queryString =
    questionMarkIndex !== -1 ? initUrl.substring(questionMarkIndex + 1) : ''
  return queryString
}

// 初始化 Facebook Pixel
function initFacebookPixel() {
  if (window.fbq) return

  window.fbq = function () {
    window.fbq.callMethod
      ? window.fbq.callMethod.apply(window.fbq, arguments)
      : window.fbq.queue.push(arguments)
  }

  if (!window._fbq) window._fbq = window.fbq
  window.fbq.push = window.fbq
  window.fbq.loaded = true
  window.fbq.version = '2.0'
  window.fbq.queue = []

  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(script)
}

// 跟踪简单事件
function callTrack(track, name) {
  if (window.fbq) {
    window.fbq(track, name)
    console.log('callTrack:', { track, name })
  }
}

// 跟踪带有参数的事件
function callTrackHasPara(track, name, valueData, currencyData) {
  if (window.fbq) {
    window.fbq(track, name, { value: valueData, currency: currencyData })
    console.log('callTrackHasPara:', { name, valueData, currencyData })
  }
}

// 获取当前的 Facebook Pixel ID
function getFbId() {
  return fb_dynamic_pixelId || ''
}

// 设置新的 Facebook Pixel ID
function setFbId(pixelId) {
  if (pixelId !== fb_dynamic_pixelId) {
    fb_dynamic_pixelId = pixelId || ''
    if (window.fbq) {
      window.fbq('init', pixelId)
      console.log('pixelId:', pixelId)
    }
  }
}

// 向 Android 应用发送事件
function sendEventToAndroid(eventData) {
  try {
    console.log('eventData to Android:', eventData)
    if (window.AndroidInterface && window.AndroidInterface.appsFlyerEvent) {
      window.AndroidInterface.appsFlyerEvent(eventData)
      console.log('发送事件 to Android:', eventData)
    }
  } catch (error) {
    console.error('Error sending event to Android:', error)
  }
}

// 调用 AppsFlyer 事件
function callAppsFlyer(eventData) {
  sendEventToAndroid(eventData)
}

// Vue 插件
const FacebookPixelPlugin = {
  install(Vue) {
    // 初始化 Facebook Pixel
    initFacebookPixel()

    // 将方法挂载到 Vue 原型链上
    Vue.prototype.$pixel = {
      getUrlIDParams,
      getUrlFBParams,
      callTrack,
      callTrackHasPara,
      getFbId,
      setFbId,
      sendEventToAndroid,
      callAppsFlyer
    }
  }
}

export default FacebookPixelPlugin
